import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../../../components/Translate';
import Tooltip from '../../general/Tooltip';
import InfoIcon from '../../../assets/icons/InfoIcon';
import './styles.css';

/*
 * A field and the three things the design always draws around it: the name
 * above, an optional hint behind a question mark beside that name, and a line
 * of help or of error underneath.
 *
 * Our inputs have always been bare - a caller wrote its own label, in its own
 * size, at its own distance - so no two forms agreed. This is the wrapper, and
 * it holds whatever control it is given: an Input, a DropdownSelect, a group of
 * checkboxes.
 *
 * error wins over hint rather than appearing under it: two lines of small print
 * where one of them is the problem is a good way to have the problem missed.
 */
const Field = ({label, required, hint, counter, help, error, htmlFor, className, children}) => (
    <div className={`field ${className}`}>
        {label && (
            <label className="field__label" htmlFor={htmlFor}>
                <Translate text={label}/>
                {required && <span className="field__required">*</span>}
                {hint && (
                    <Tooltip text={hint} inRightSide style={{display: 'flex'}}>
                        <span className="field__hint-icon">
                            <InfoIcon width={14} height={14} stroke="currentColor"/>
                        </span>
                    </Tooltip>
                )}
                {counter && <span className="field__counter">{counter}</span>}
            </label>
        )}

        {children}

        {error
            ? <p className="field__message field__message--error">{error}</p>
            : help && <p className="field__message"><Translate text={help}/></p>}
    </div>
);

Field.propTypes = {
    /* translation keys, not finished strings - every other label in the app is */
    label: PropTypes.string,
    hint: PropTypes.string,
    /* already a finished string - a character count, a limit */
    counter: PropTypes.node,
    help: PropTypes.string,
    /* already translated: it usually comes back from the server or a validator */
    error: PropTypes.node,
    required: PropTypes.bool,
    htmlFor: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
};

Field.defaultProps = {
    required: false,
    className: '',
};

export default Field;



// WEBPACK FOOTER //
// ./src/components-new/form/Field/index.jsx